import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CertificationsList from "@/components/CertificationsList";

export default function Certifications() {
    return (
        <>
            <PageHeader
                crumb="HOME / CERTIFICATIONS"
                eyebrow="05 — PROOF OF LEARNING"
                lines={["CERTIFI", "CATIONS"]}
                sub="Credentials collected along the way."
            />
            <section
                className="px-5 lg:px-12 xl:px-16 py-14 lg:py-20 pb-24"
                data-testid="certifications-page"
            >
                <Reveal>
                    <CertificationsList />
                </Reveal>
            </section>
        </>
    );
}
